import axios from 'axios'

export default {
  update (id, data) {
    return axios.patch('/api/v2/facets/' + id, data, {
      headers: {'Content-Type': 'application/merge-patch+json'}
    })
  },
  tree(query, parentId, selectedFacets, openedFacets, onlineFilter, noticeCollectionsFilter, onlyHasImage, onlyEnabled, nextId = null) {
    const params = {
      query: query,
      f: selectedFacets,
      o: openedFacets,
      onlineFilter: onlineFilter,
      noticeCollectionsFilter: noticeCollectionsFilter,
      onlyEnabled: onlyEnabled
    };
    if (onlyHasImage !== 'all') params.onlyHasImage = onlyHasImage;
    if(parentId) {
      if(nextId) params.after = nextId;
      params.o = params.o || [],
      params.o.push(parentId);
      return axios.get(`/api/v2/facets/${parentId}/children`, { params });
    }
    return axios.get('/api/v2/facets/tree', { params })
  }
}
